import { Component } from "react";
import ErrorPageComponent from "./ErrorPageComponent";

export default class PageErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Page rendering failed:", error, info);
  }

  render() {
    return this.state.hasError ? (
      <ErrorPageComponent code="500" />
    ) : (
      this.props.children
    );
  }
}
